<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    no-close-on-backdrop
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <label tag="div">Código</label>
      <b-form-input
        type="text"
        placeholder="Código"
        v-model="form.cd"
        name="cd"
      >
      </b-form-input>
      <b-form-feedback
        v-text="form.errors.get('cd')"
        v-if="form.errors.has('cd')"
      ></b-form-feedback>

      <label tag="div">Descrição</label>
      <b-form-input
        type="text"
        placeholder="Descrição"
        v-model="form.descr"
        name="descr"
      >
      </b-form-input>
      <b-form-feedback
        v-text="form.errors.get('descr')"
        v-if="form.errors.has('descr')"
      ></b-form-feedback>

      <label tag="div">Tipo fluxo</label>
      <multiselect
        v-model="tpFluxoSelected"
        :options="optionsLivTpFluxo"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('tp_fluxo.value')"
        v-if="form.errors.has('tp_fluxo.value')"
      ></b-form-feedback>

      <label tag="div">Status</label>
      <multiselect
        v-model="statusSelected"
        :options="optionsLivStatus"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('status.value')"
        v-if="form.errors.has('status.value')"
      ></b-form-feedback>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      statusSelected: [],
      tpFluxoSelected: [],
      optionsLivStatus: [],
      optionsLivTpFluxo: [],
      errors_array: [],
      form: new Form({
        cd: "",
        descr: "",
        param_id: "",
        status: "",
        tp_fluxo: ""
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned"
        },
        {
          name: "cd",
          title: "Código",
          sortField: "cd"
        },
        {
          name: "descr",
          title: "Descrição",
          sortField: "descr"
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status"
        },
        {
          name: "__slot:tp_fluxo",
          title: "Fluxo"
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned"
        }
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  watch: {
    statusSelected(obj) {
      this.form.status = obj.value;
    },
    tpFluxoSelected(obj) {
      this.form.tp_fluxo = obj.value;
    }
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.param_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.statusSelected = []
      this.tpFluxoSelected = []
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.statusSelected = []
      this.tpFluxoSelected = []
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.statusSelected = {
        label: data.status.descr,
        value: data.status.valor
      };
      this.tpFluxoSelected = {
        label: data.tp_fluxo.descr,
        value: data.tp_fluxo.valor
      };
      this.form.param_id = id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/" + this.rota + "/store")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/" + this.rota + "/update/" + id)
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/" + this.rota + "/status")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/regiao/jsonlistgeral")
        .then(response => {
          response.tp_fluxo.forEach(obj => {
            this.optionsLivTpFluxo.push({ label: obj.descr, value: obj.valor });
          });
          response.status.forEach(obj => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this);
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
